import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useReorderChapters(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({
      gameId,
      chapterIds,
    }: {
      gameId: string;
      chapterIds: (number | string)[];
    }) => {
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/chapters/reorder/`,
        {chapter_ids: chapterIds},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
